import React, { useEffect } from "react";

export default function OwnerOccupiedField({
  register,
  fieldNamePrefix = "",
  watch,
  setValue,
  filterData,
}) {
  const occupaid = watch(`${fieldNamePrefix}_occupaid`);
  useEffect(() => {
    if (setValue && occupaid !== undefined) {
      setValue("occupaid", occupaid);
      setValue("owner_occupaid", occupaid);
      setValue("recommend_occupaid", occupaid);
    }
  }, [occupaid, setValue]);
  return (
    <>
      <div className="lbl_btn">
        <input
          type="checkbox"
          name={`${fieldNamePrefix}_occupaid`}
          id={`${fieldNamePrefix}_occupaid`}
          value="occupaid"
          {...register(`${fieldNamePrefix}_occupaid`)}
          defaultChecked={filterData?.[`${fieldNamePrefix}_occupaid`]}
        />

        <label htmlFor="occupaid" className="dim_dark_text f_s_15">
          Owner Occupied Property
        </label>
      </div>
    </>
  );
}
